import { ActionResult, DirectoryItem } from '../types'
import { ExecutableAction } from './action'

export class DeleteAction extends ExecutableAction {
  static readonly actionName = 'delete'
  public readonly actionName = DeleteAction.actionName

  constructor(readonly items: DirectoryItem[]) {
    super()
  }

  override async execute(tree): Promise<ActionResult> {
    if (!this.items || this.items.length === 0)
      return {
        status: 'info',
        message: 'No items selected for deletion.'
      }
    let allSucceeded = true
    try {
      // await Promise.all(this.items.map(async (item) => deleteDirectoryItem(item)))
      for (const item of this.items) {
        if (!tree.deleteNodeById(item.id)) {
          allSucceeded = false
          console.warn(`Failed to delete item: ${item.id}`)
        }
      }
      if (allSucceeded) {
        return {
          status: 'success',
          data: undefined
        }
      } else {
        return {
          status: 'error',
          message: 'Some items could not be deleted.'
        }
      }
    } catch (e) {
      return {
        status: 'error',
        message: 'Some items could not be deleted.',
        error: e instanceof Error ? e : undefined
      }
    }
  }

  override async undo(): Promise<ActionResult> {
    // Logic to undo the deletion would go here
    return { status: 'success', data: undefined }
  }
}
